import { useCallback } from 'react'

import { normalizeExecuteCommandBody } from '@helpers'

import { getFormData } from '../helpers'
import { ExecuteCommandRecordArgs } from '../types'

import { useExecuteCommandMutationWithFixedKey } from './useExecuteCommandMutationWithFixedKey'

export const useCreateObjectDataRecordWithFixedKey = (globalId: string) => {
  const fixedCacheKey = `create-object-data-record-${globalId}`

  const [executeCommand, executeCommandResult] =
    useExecuteCommandMutationWithFixedKey(fixedCacheKey)

  const triggerCreate = useCallback(
    (args: ExecuteCommandRecordArgs) => {
      if (args.isFormData) {
        return executeCommand({
          method: args.method,
          objectCode: args.objectCode,
          commandCode: args.commandCode,
          resource: args.resource,
          params: args.params,
          body: getFormData(args.record),
        })
      }

      const body = args.body
        ? normalizeExecuteCommandBody(args.body as Record<string, unknown>)
        : normalizeExecuteCommandBody(args.record)

      return executeCommand({
        method: args.method,
        objectCode: args.objectCode,
        commandCode: args.commandCode,
        resource: args.resource,
        params: args.params,
        body,
      })
    },
    [executeCommand]
  )

  return [triggerCreate, executeCommandResult] as const
}
